import swal from 'sweetalert2';

const alert_simple = (texto:string) => {
   swal.fire(
            {
                position: 'center',
                icon: 'success',
                title: texto,
                showConfirmButton: false,
                timer: 1500
            }
        )
}

export const ventana = (titulo:string,mensaje:string,tipo:any) => {
    swal.fire(
        titulo,
        mensaje,
        tipo,
    )
 }

export default alert_simple;